import { render, staticRenderFns } from "./info-pax.vue?vue&type=template&id=18d195d4"
import script from "./info-pax.vue?vue&type=script&lang=js"
export * from "./info-pax.vue?vue&type=script&lang=js"
import style0 from "./info-pax.vue?vue&type=style&index=0&id=18d195d4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports